import React from "react";
import { Dialog, DialogContent, IconButton, useMediaQuery } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";

type PreviewDialogProps = {
    open: boolean;
    handleOnClose: () => void;
    previewContent: string[];
};

const PreviewDialog = ({ open, handleOnClose, previewContent }: PreviewDialogProps) => {
    const { t } = useTranslation();
    const isWideScreen = useMediaQuery("(min-width:800px)");

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Escape") {
            e.preventDefault();
            handleOnClose();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleOnClose}
            fullScreen
            aria-labelledby="certificate-preview-title"
            aria-describedby="certificate-preview-description"
            onKeyDown={handleKeyDown}
            className="pc-app"
        >
            <IconButton
                onClick={handleOnClose}
                aria-label={t(
                    "certificate_validator.accessibility.close_fullscreen_preview",
                    "Close full screen preview"
                )}
                style={{
                    position: "absolute",
                    top: isWideScreen ? "15px" : "2px",
                    right: isWideScreen ? "15px" : "2px",
                    zIndex: 2,
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    color: "white",
                    minWidth: "44px",
                    minHeight: "44px",
                }}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent>
                <h1 id="certificate-preview-title" className="sr-only">
                    {t("certificate_validator.accessibility.fullscreen_preview", "Certificate Fullscreen Preview")}
                </h1>

                <div id="certificate-preview-description" className="sr-only">
                    {t("certificate_validator.accessibility.fullscreen_preview_description", {
                        count: previewContent.length,
                    })}
                </div>

                {previewContent.map((content, index) => (
                    <img
                        key={index}
                        src={content}
                        alt={t("certificate_validator.accessibility.fullscreen_preview_page", {
                            page: index + 1,
                            total: previewContent.length,
                        })}
                        style={{
                            maxHeight: "100vh",
                            maxWidth: "100%",
                            width: "auto",
                            height: "auto",
                            display: "block",
                            margin: "auto",
                            padding: "10px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            marginBottom: "16px",
                            objectFit: "contain",
                        }}
                    />
                ))}
            </DialogContent>
        </Dialog>
    );
};

export default PreviewDialog;
